module.exports = __webpack_public_path__ + "static/media/biponon.f0eee251.svg";